module.exports = __webpack_public_path__ + "assets/img/profile-goals-old.5871bfec.svg";